import React from "react"
import "../../assets/css/pages/calendar/calendar-day-tag.css"
import PropTypes from "prop-types"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCloudSunRain,
  faLeaf,
  faDna,
  faChartSimple,
  faGears,
  faVolcano,
  faGear,
  faHand,
  faRocket
} from "@fortawesome/free-solid-svg-icons"
library.add(faCloudSunRain, faLeaf, faDna, faChartSimple, faGears, faVolcano, faGear, faHand)

const CalendarDayTag = ({
  assignment,
  setSelectedAssignment,
  isSelectedAssignment,
  selectedTagRef
}) => {
  let tagTitle
  let contentType
  let moduleIcon
  if (assignment.isSandboxUnlock) {
    switch (assignment.moduleId) {
      case 1:
        tagTitle = "Ecology Sandbox (The H.E.L.O.)"
        contentType = "sandbox-unlock"
        moduleIcon = faLeaf
        break
      case 2:
        tagTitle = "Growth & Genetics Sandbox (The Drakonarium)"
        contentType = "sandbox-unlock"
        moduleIcon = faDna
        break
      case 6:
        tagTitle = "Weather & Climate Sandbox (The O.R.B.)"
        contentType = "sandbox-unlock"
        moduleIcon = faCloudSunRain
        break
    }
  } else if (assignment.contentType === "expedition") {
    moduleIcon = faRocket
  } else {
    tagTitle = assignment.title
    contentType = assignment.contentType
    switch (assignment.moduleId) {
      case 1:
        moduleIcon = faLeaf
        break
      case 2:
        moduleIcon = faDna
        break
      case 3:
        moduleIcon = faHand
        break
      case 5:
        moduleIcon = faGear
        break
      case 6:
        moduleIcon = faCloudSunRain
        break
      case 10:
        moduleIcon = faChartSimple
        break
      case 11:
        moduleIcon = faVolcano
        break
    }
  }
  return (
    <div
      className={
        "calendar-day-tag " +
        contentType +
        " " +
        (contentType === "storyline" ? assignment.sequenceOrder : "") +
        (isSelectedAssignment ? " selected-assignment" : "")
      }
      onClick={() => {
        setSelectedAssignment(assignment)
      }}
      ref={selectedTagRef}
    >
      <FontAwesomeIcon className='module-icon' icon={moduleIcon} />
      <p>{tagTitle}</p>
    </div>
  )
}

export default CalendarDayTag

CalendarDayTag.propTypes = {
  assignment: PropTypes.object,
  quest: PropTypes.object
}
